export const social_media = [
  // --- 內容創作 ---
  { char: '📸', name: 'Camera', nameZh: '拍照紀錄', keywords: ['instagram', 'photo', 'ootd'], hot: true },
  { char: '🤳', name: 'Selfie', nameZh: '自拍', keywords: ['selfie', 'me', 'vlog'] },
  { char: '🎬', name: 'Clapper', nameZh: '短影音', keywords: ['reels', 'tiktok', 'video'], hot: true },
  { char: '🎥', name: 'Movie', nameZh: '長片紀錄', keywords: ['youtube', 'vlog', 'story'] },
  { char: '📱', name: 'Phone', nameZh: '社群載體', keywords: ['social', 'app', 'link'] },
  { char: '🎤', name: 'Mic', nameZh: 'Podcast', keywords: ['audio', 'talk', 'voice'], hot: true },
  { char: '🎧', name: 'Headphones', nameZh: '沉浸聽感', keywords: ['music', 'listen', 'audio'] },
  
  // --- 互動與行銷 ---
  { char: '💡', name: 'Idea', nameZh: '乾貨分享', keywords: ['tips', 'learn', 'knowledge'], hot: true },
  { char: '💯', name: '100', nameZh: '滿分推薦', keywords: ['best', 'top', 'perfect'], hot: true },
  { char: '🔥', name: 'Fire', nameZh: '爆紅趨勢', keywords: ['trend', 'hot', 'viral'], hot: true },
  { char: '✨', name: 'Sparkles', nameZh: '質感點綴', keywords: ['magic', 'aesthetic', 'shine'], hot: true },
  { char: '📌', name: 'Pushpin', nameZh: '重點標記', keywords: ['note', 'important', 'save'] },
  { char: '💬', name: 'Comment', nameZh: '留言互動', keywords: ['chat', 'reply', 'ask'] },
  { char: '🔔', name: 'Bell', nameZh: '開啟通知', keywords: ['notice', 'subscribe', 'alert'] },
  { char: '🚀', name: 'Rocket', nameZh: '數據起飛', keywords: ['growth', 'launch', 'fast'], hot: true },
  { char: '🎁', name: 'Gift', nameZh: '抽獎活動', keywords: ['giveaway', 'prize', 'win'] },
  { char: '🌈', name: 'Rainbow', nameZh: '多元生活', keywords: ['vibe', 'happy', 'life'] },
  { char: '🧿', name: 'Nazar', nameZh: '質感小物', keywords: ['accessory', 'blue', 'lucky'] },
  { char: '💎', name: 'Gem', nameZh: '精品推薦', keywords: ['luxury', 'best', 'diamond'] },
  { char: '📩', name: 'DM', nameZh: '私訊詢問', keywords: ['contact', 'message', 'mail'] },
];